import AjaxForm from '../../utilities/ajax-form';
import AjaxReloadPartial from '../../utilities/AjaxReloadPartial';
import CheckoutAccordions from './CheckoutAccordions';

export default class UpdateCartEmail extends AjaxForm { // Step #1

  handleSuccess(json) {


    new AjaxReloadPartial('.js-update-checkout', function() {
      new CheckoutAccordions('.js-personal-details').open();
    }, '.js-update-cart-email-address');
  }

  handleErrors(json) {

    if(json?.errors?.email?.includes("This email belongs to a registered user. Please log in to proceed.")) {
      new AjaxReloadPartial('.js-update-checkout', function() {
        new CheckoutAccordions('.js-personal-details').open();
      }, '.js-update-cart-email-address');
    }


    let errors = this.addErrorsToFormInputs(json.errors);

    if(! errors ) {
      // if there are errors but they can't be attached to form inputs, list errors at bottom of form.
      this.handleError(json);
    }
  }

};